/**
 * The point where a line from `from` through `to` leaves the pane; never before `to`.
 *
 * @param {{ x: number, y: number }} from - CSS px of the pane
 * @param {{ x: number, y: number }} to
 * @param {{ width: number, height: number }} pane
 * @returns {{ x: number, y: number }}
 */
export const rayEnd = (from, to, { width, height }) => {
  const deltaX = to.x - from.x;
  const deltaY = to.y - from.y;

  if (deltaX === 0 && deltaY === 0) return to;

  const toEdgeX = deltaX === 0 ? Infinity : ((deltaX > 0 ? width : 0) - from.x) / deltaX;
  const toEdgeY = deltaY === 0 ? Infinity : ((deltaY > 0 ? height : 0) - from.y) / deltaY;
  const ratio = Math.max(1, Math.min(toEdgeX, toEdgeY));

  return { x: from.x + deltaX * ratio, y: from.y + deltaY * ratio };
};
